import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ImageLinkList",
    component: () => (__SERVER__ ? require("./image-link-list-view") : import("./image-link-list-view"))
});

export default definition;
